<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="20" viewBox="0 0 26 20" fill="none">
    <path
      d="M2 2H24"
      stroke="url(#paint0_linear_5370_4300)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M2 10H24"
      stroke="url(#paint1_linear_5370_4300)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M2 18H24"
      stroke="url(#paint2_linear_5370_4300)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5370_4300"
        x1="2"
        y1="2"
        x2="2.09165"
        y2="4.00266"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5370_4300"
        x1="2"
        y1="10"
        x2="2.09165"
        y2="12.0027"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5370_4300"
        x1="2"
        y1="18"
        x2="2.09165"
        y2="20.0027"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.fill-1 {
  stop-color: #df252a;
}

.fill-2 {
  stop-color: #a20004;
}
</style>
